var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(this.$route.name != 'Home')?_c('Navbar'):_vm._e(),_c('v-main',{staticClass:"background"},[_c('router-view')],1),_c('v-divider',{staticClass:"ma-2"}),(this.$route.name == 'Home')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }